module.exports = __webpack_public_path__ + "static/media/2.5beb16d8.jpg";